import React, { useEffect, useState } from 'react';
import logo2 from '../../../assets/images/logo2.png';
import logo from '../../../assets/images/logo.png';

import { Link } from 'react-router-dom';
function Navbar({ checkScroll = true }) {
  const [reachedTop, setReachedTop] = useState(checkScroll);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;
      const hasReachedTop = scrollTop === 0;

      setReachedTop(hasReachedTop);
    };
    if (checkScroll) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (reachedTop) {
    }
  }, [reachedTop]);

  return (
    <header
      className={`header js-header max-w-full w-screen  ${
        reachedTop ? 'header--clear' : ''
      }`}
    >
      <div className="header__top js-header__top max-w-full">
        <a href="/" className="header__logo">
          <img className="w-24 md:w-48 " src={reachedTop ? logo2 : logo} />
        </a>

        <div className="header__links header__links--divider l-false m-flex">
          <button className="header__icon js-search--toggle">
            <svg className="icon-search" role="img">
              <use href="/images/svg-symbols.svg?m=ad243263cd#icon-search"></use>
            </svg>
          </button>
          <a href="#" className="header__icon text-black">
            <svg className="icon-account" role="img">
              <use href="/images/svg-symbols.svg?m=ad243263cd#icon-account"></use>
            </svg>
          </a>
        </div>
      </div>
      <div className="header__bottom">
        <div className="header__nav">
          <nav className="header-nav js-header-nav">
            <div className="header-nav__indicator js-header-nav__indicator"></div>
            <ul className="header-nav__list font-bold text-2xl">
              <li
                className="header-nav__item js-header-nav__item"
                data-nav-item="products"
                data-sublinks="2"
              >
                <Link to={'/productos'} className="header-nav__link">
                  PRODUCTOS
                  <svg className="icon-arrow-small-right" role="img">
                    <use href="/images/svg-symbols.svg?m=ad243263cd#icon-arrow-small-right"></use>
                  </svg>
                </Link>
                <div className="header-nav__content">
                  <div className="grid grid--flush grid--flex grid--max-width">
                    <div className="l-three-quarters m-full">
                      <div className="header-nav__container header-nav__container--products">
                        <div className="grid grid--flush ">
                          <div className="l-one-third m-full">
                            <p className="header-nav__title">
                              Browse by Category
                            </p>
                            <div className="header-sub-content ">
                              <ul className="header-nav__sub-list header-nav__sub-list--stack">
                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-category=bathroom-lighting"
                                  >
                                    Bathroom
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-category=coastal-lighting	"
                                  >
                                    Coastal
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-category=exterior-lighting	"
                                  >
                                    Outdoor
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-category=interior-lighting	"
                                  >
                                    Indoor
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/aw22-home"
                                  >
                                    New In
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link header-nav__sub-link--all"
                                    href="/products"
                                  >
                                    View all
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="l-two-thirds m-full">
                            <p className="header-nav__title">Browse by Type</p>
                            <div className="header-sub-content header-sub-content--flex">
                              <ul className="header-nav__sub-list header-nav__sub-list--stack">
                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=ceiling-lights	"
                                  >
                                    Ceiling Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=downlights	"
                                  >
                                    Downlights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=floor-lights	"
                                  >
                                    Floor Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=ground-lights	"
                                  >
                                    Ground Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=marker-lights	"
                                  >
                                    Marker Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=pendants	"
                                  >
                                    Pendants
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=picture-lights	"
                                  >
                                    Picture Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=reading-lights	"
                                  >
                                    Reading Lights
                                  </a>
                                </li>
                              </ul>
                              <ul className="header-nav__sub-list header-nav__sub-list--stack">
                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=shades	"
                                  >
                                    Shades
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=spotlights	"
                                  >
                                    Spotlights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=table-lights	"
                                  >
                                    Table Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=track-lighting	"
                                  >
                                    Track Lighting
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-type=wall-lights	"
                                  >
                                    Wall Lights
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link "
                                    href="/products?product-category=accessories"
                                  >
                                    Lamps &amp; Accessories
                                  </a>
                                </li>

                                <li className="header-nav__sub-item">
                                  <a
                                    className="header-nav__sub-link header-nav__sub-link--all"
                                    href="/products"
                                  >
                                    View all
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="header-nav__sub-item l-false m-true">
                            <a
                              className="header-nav__sub-link header-nav__sub-link--all"
                              href="/collections"
                            >
                              Discover our Collections
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="l-one-quarter m-false">
                      <a href="/collections" className="nav-feature">
                        <figure className="nav-feature__image is-object-fit">
                          <img
                            alt="Astro Ascoli 4 Bar in Matt White"
                            height="225"
                            loading="lazy"
                            sizes="calc(25vw - 10px)"
                            src="https://assets.astrolighting.com/images/nav-feature--small/243543-ascoli-4-bar-lifestyle-1-square.jpg"
                            srcset="
                              https://assets.astrolighting.com/images/nav-feature--small/243543-ascoli-4-bar-lifestyle-1-square.jpg 300w,
                              https://assets.astrolighting.com/images/nav-feature--large/243544-ascoli-4-bar-lifestyle-1-square.jpg 600w
                            "
                            width="300"
                          />
                        </figure>
                        <span className="button button--plain button--has-icon">
                          <span>
                            Discover our Collections
                            <svg className="icon-arrow-mid-right" role="img">
                              <use href="/images/svg-symbols.svg?m=ad243263cd#icon-arrow-mid-right"></use>
                            </svg>
                          </span>
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              </li>

              <li
                className="header-nav__item js-header-nav__item"
                data-nav-item="about"
                data-sublinks="0"
              >
                <a className="header-nav__link" href="#about">
                  Contacto
                  <svg className="icon-arrow-small-right" role="img">
                    <use href="/images/svg-symbols.svg?m=ad243263cd#icon-arrow-small-right"></use>
                  </svg>
                </a>
                <div className="header-nav__content">
                  <div className="header-nav__container">
                    <div className="grid grid--flush">
                      <div className="l-five-eighths m-full">
                        <ul className="header-nav__sub-list"></ul>
                      </div>
                      <div className="l-three-eighths m-false">
                        <a href="" className="nav-feature nav-feature--tight">
                          {' '}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              {/*
              <li
                className="header-nav__item js-header-nav__item"
                data-nav-item="where-to-buy"
                data-sublinks="0"
              >
                <a className="header-nav__link" href="/where-to-buy">
                  Donde compraR
                  <svg className="icon-arrow-small-right" role="img">
                    <use href="/images/svg-symbols.svg?m=ad243263cd#icon-arrow-small-right"></use>
                  </svg>
                </a>
                <div className="header-nav__content">
                  <div className="header-nav__container">
                    <div className="grid grid--flush">
                      <div className="l-five-eighths m-full">
                        <ul className="header-nav__sub-list"></ul>
                      </div>
                      <div className="l-three-eighths m-false">
                        <a href="" className="nav-feature nav-feature--tight">
                          {' '}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>*/}
            </ul>
          </nav>

          <div className="header-background js-header-background"></div>
        </div>
      </div>
    </header>
  );
}
export default Navbar;
